module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "ch-num"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_vm._v("Chapter One")])]), _c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_c('h2', {
    staticClass: "ch-title"
  }, [_vm._v("The Formation of MI(R)")])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page1"
    }
  }, [_vm._v("Inspired by the success of the Arab Revolt and its attached British officers, in January 1918 the War Office had created a prototype special forces unit under Major General Lionel Dunsterville (Dunsterforce). Its task was to unify the disparate anti-Bolshevik and anti-Turkish groups fighting in Persia (Iran) and the Caucasus, to secure the important oil installations at Baku and protect the strategically important Trans-Caucasian railway. Success would also secure the exposed eastern flank of the British troops in Mesopotamia, previously protected by the Czarist forces. Dunsterforce comprised up to a thousand men who were required to be of ‘strong character and adventurous spirit, especially good stamina, capable of organizing, training and eventually leading, irregular troops’."), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_1",
      "id": "fn1_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" The project had only limited success but set an important precedent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the 1920s and 1930s Britain faced guerrilla warfare at the hands of the IRA, Indian nationalists and the Arab Revolt in Palestine. Together with the operations of Chinese guerrillas opposing the Japanese invasion of 1937, such attacks emphasized the need to better counter guerrilla tactics and for the War Office to incorporate irregular warfare into its own planning. Orde Wingate’s Special Night Squads were formed in Palestine in June 1938 from British personnel, Jewish police and members of the paramilitary Haganah, using guerrilla tactics to contain the Arab insurgents, but brought accusations of acting as ‘death squads’. A new urgency came from the Germans’ successful use of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Sudetendeutsche Freikorps")]), _vm._v(" (which became the basis of the Branden-burg special forces regiment) to carry out subversion in Bohemia and Moravia during the dismemberment of Czechoslovakia from 1938. Fear of enemy guerrilla operations and ‘fifth column’ activities (first given a name in the Spanish Civil War of 1936–1939) increasingly took hold of the military and diplomatic psyche and seemed to threaten the conventional approach to fighting a war.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The War Office needed a strategy for both countering and developing these ‘ungentlemanly’ tactics for its own ends. In 1936 it had formed a small research section innocuously titled General Service (Research) under the Deputy Chief of the Imperial General Staff (DCIGS) to provide a fellowship for an officer to carry out a period of undisturbed research into a topic that was outside the scope of everyday War Office responsibilities. Its charter was"), _c('a', {
    attrs: {
      "id": "page2"
    }
  }, [_vm._v(" to research into problems of tactics and organization, consulting with other branches of the War Office and Commands in order to collect new ideas, and to liaise with technical research branches."), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_2",
      "id": "fn1_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")]), _vm._v(" The DCIGS explained: ‘This section must be small, almost anonymous, go where they like, talk to whom they like, but be kept from files, correspondence and telephone calls.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_3",
      "id": "fn1_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" The existence of GS(R) was belatedly made public on 10 March 1938 when, in a statement to the House of Commons, the Secretary of State for War (Hore-Belisha) announced ‘When so much instruction is to be gained from present events the absence of any branch exclusively concerned with pure military research is noticeable, and a small section to study the practice and lessons of actual warfare will be established.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_4",
      "id": "fn1_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" GS(R) was not secret "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("per se")]), _vm._v(" but it was to maintain a low profile so as to keep it free from interruption and interference within the War Office.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The reports produced by the early incumbents were considered useful but had little practical impact (Fig. 1). This changed when, in December 1938, the post was offered to Major Jo Holland, a Royal Engineer staff officer in the War Office, then recovering from a bout of recurring illness arising out of his First World War service in Salonika.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("J.C.F. ‘Jo’ Holland (Plates "), _c('span', {
    attrs: {
      "href": "#/xhtml/Plates#P_1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/xhtml/Plates#P_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")]), _vm._v(") was born in India, the son of a noted geologist, and was universally described as being intelligent, imaginative and practical. Full of humour, he also had a ruthless streak. His obituary by Major General William Broomhall recalled:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Being able to see the solution to a difficult problem more quickly than most people, he would at once initiate a course of action to achieve that solution. Thereafter, he would ensure that nobody impeded the achievement of the object … Persons less able than himself (of whom there were many) who could not see so clearly how the result was being achieved were apt to resent the ruthless way he pursued the object and he inevitably made some enemies."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_5",
      "id": "fn1_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Figure 1. GS(R) Reports 1936–1939. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("(TNA HS8/258)")])]), _vm._v(" "), _c('table', {
    staticClass: "table2"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "td1j"
  }, [_vm._v("No. 1")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("The Reorganization of the War Office")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1j"
  }, [_vm._v("No. 2")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Employment of Historians by the War Office in a consultative capacity")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1j"
  }, [_vm._v("No. 3")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Reorganization of the General Staff")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1j"
  }, [_vm._v("No. 4")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Army Requirements from the RAF in modern warfare")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1j"
  }, [_vm._v("No. 5")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Organization of Armoured and Mobile Units and Formations")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1j"
  }, [_vm._v("No. 6")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Training of the Army")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td1j"
  }, [_vm._v("No. 7")]), _vm._v(" "), _c('td', {
    staticClass: "td2"
  }, [_vm._v("Considerations from the Wars in Spain and China with regard to certain aspects of\nArmy policy")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "td11"
  }, [_vm._v("No. 8")]), _vm._v(" "), _c('td', {
    staticClass: "td22"
  }, [_vm._v("Investigation of the possibilities of Guerrilla Activities")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_vm._v("His frustration with ponderous War Office procedures was expressed in bursts of fiery temper and Holland’s secretary in MI(R), Joan Bright, remembered how ‘I can feel now the quick downward movement by which I ducked the impact of a book flung at my head one day on opening the door of his office’."), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_6",
      "id": "fn1_6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")]), _vm._v(" But Holland soon recovered and he inspired great respect and affection. For Joan Bright: ‘The engine which drove us was Colonel Holland. We admired him, feared him. Loved him.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_7",
      "id": "fn1_7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" He was more relaxed outside his work environment, and his daughter Elizabeth remembers him as effervescent, a skilled raconteur and the automatic centre of attention at parties, but in common with the other tight-lipped pioneers of Intelligence work at the time, he never spoke of his work in MI(R)!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Holland had been commissioned into the Royal Engineers in 1914 and developed a speciality in Wireless Signals (until 1920 the Royal Engineers were responsible for all military communications). He served in Salonika with Divisional Signals and was then seconded to the Royal Flying Corps as an aerial observer. In October 1918 he was awarded the DFC after having completed over 200 hours of long-distance reconnaissance and contact patrols but there is no basis in the myth that he served with Lawrence of Arabia on aerial reconnaissance."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_8",
      "id": "fn1_8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" During service in the gruelling Salonika campaign, he contracted amoebic dysentery, leading to recurring bouts of illness which significantly impaired his career. His RAF squadron moved to Ireland in 1919 but he then transferred back to the Royal Engineers and served in the Special Signal Company as a temporary major. It is uncertain if he was officially connected with any Intelligence work but he certainly had direct experience of the IRA.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the night of 9 January 1921, aged 24, he was shot in the right chest during a mysterious confrontation in a Cork public house."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_9",
      "id": "fn1_9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" He had been posted to Chatham in October 1920 on a signals course but during the Christmas vacation it is claimed in his Royal Engineers obituary that he had unofficially returned to Ireland to take revenge after the IRA had killed a friend. The obituary maintained he waited in a public house for the killer to appear, indicating he knew the identity of the IRA man and that this was, therefore, likely to be a sanctioned operation. Whilst waiting, the barmaid reputedly urged him to leave but he refused, which begs the question how she knew that Holland was a British officer and the nature of his mission."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_10",
      "id": "fn1_10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Shots were fired and Holland staggered out of the pub wounded and was rescued by a conveniently passing armoured car. The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cork Constitution")]), _vm._v(" of Monday, 10 January reported an ‘Exciting City Incident’ in which, on the previous night at around 8.00pm in the South Mall/Anglesea Street area, ‘five revolver shots in quick succession’ were heard but there were no signs of an ambush. When the police arrived they failed to elicit any information on the shooting."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_11",
      "id": "fn1_11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" Holland subsequently received £125 compensation for ‘gunshot wounds through body’, and £5 for expenses in making the claim."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_12",
      "id": "fn1_12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" This may have been"), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v(" a semi-official Intelligence mission (not unknown in Ireland at the time), with the story as recounted in the Royal Engineers obituary being a long-surviving cover story. The incident does not appear in his service record and, despite Holland’s reputation as a raconteur, the story was never told to his family.")])]), _c('a', {
    attrs: {
      "id": "page4"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v("After his eventful time in Ireland, Holland served in a succession of divisional staff posts before being posted in 1928 to India, where he served on the North West frontier and attended Quetta Staff College. Promoted major in 1933, Holland returned to England and became a staff officer in Southern and then Northern Command. He worked at the War Office from April 1936 in the wide-ranging Staff Duties Directorate, first in SD2 (War Organization) and from September 1937 in SD7 (organization and equipment of armoured vehicles). There he would have met another Royal Engineer, Laurence Grand (")]), _c('span', {
    attrs: {
      "href": "#/xhtml/Plates#P_4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 4")]), _vm._v("), who from 1935 to 1938 was Deputy Assistant Director of Mechanization. In 1938 Holland was due for posting overseas but in October he was declared unfit after being diagnosed with a duodenal ulcer. As a consequence, in December he accepted the opportunity given by the VCIGS to take up the vacant research post in GS(R) and carry out a piece of research exploring the methodology for a future war with Germany. The specific topic was to be irregular warfare, focused initially on defensive counter-measures to protect the Empire from the threat of German-inspired subversion and insurrection. This followed long-running efforts by the War Office to establish clear guidelines for dealing with guerrilla warfare, beginning with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Notes on Guerrilla Warfare in Ireland")]), _vm._v(" (1921) which morphed into "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Imperial Policing and Irregular Warfare")]), _vm._v(" (1933)."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_13",
      "id": "fn1_13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" Holland’s lack of formal Intelligence expertise was symptomatic of the ad hoc nature of recruitment to Military Intelligence at the time. This was considered only a temporary posting, probably with low expectation, but Holland (with the considerable assistance of Laurence Grand, now on secondment to SIS as head of Section D), managed to establish a radical new field of study in the War Office. Section D had been formed a few months earlier in April 1938 to progress plans for clandestine civilian sabotage and subversion from within SIS. The topic chosen for Holland may reflect a concern of the War Office not to be left behind, and wanting to explore the use of guerrillas on a military (more respectable) basis.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both Holland and Grand believed that guerrilla warfare was likely to be important in any coming war, capable of diverting large numbers of troops from attacking conventional forces and contributing to the expected implosion of the Nazi state by economic disruption. Holland wanted to establish a doctrinal approach to organizing irregular warfare on a para-military basis but rather than managing an executive arm like Section D, Holland believed the role of GS(R)/MI(R) ‘was to produce ideas, work them up to a practical stage and then cast them off to grow under their own steam under whomever in MI(R) he had brought up for the purpose’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_14",
      "id": "fn1_14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" In accepting this limitation,"), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v(" fellow MI(R) officer Colin Gubbins saw Holland as ‘completely unselfish … [and] had no intention of building an empire for himself’."), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_15",
      "id": "fn1_15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" Similarly, for Joan Bright Holland ‘never sought personal aggrandisement’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_16",
      "id": "fn1_16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" M.R.D. Foot interpreted such comments as representing ‘an unusually modest and selfeffacing member of a traditionally self-effacing caste’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_17",
      "id": "fn1_17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" Holland did not lack ambition, but instead of building an empire for himself, he firmly believed that irregular operations should be the responsibility of the existing operational departments of the War Office, modernized to incorporate this new form of warfare, rather than create ad hoc new structures: ‘I have always thought that each appropriate branch of the General Staff ought to deal with the various activities which we have undertaken, except for the fact that it is probably useful to have a branch with a certain amount of freedom and contact with unusual sources of information and possibilities of action.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_18",
      "id": "fn1_18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The concept of guerrilla warfare was popular at the time, greatly inspired by the posthumous publication of T.E. Lawrence’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Seven Pillars of Wisdom")]), _vm._v(" in 1935. In that year Second Lieutenant Harry Fox-Davies of the Durham Light Infantry (who later assisted in raising the Middle East Commandos) had promoted guerrilla warfare to his then divisional commander, Archibald Wavell. Fox-Davies pointed out that ‘a handful of men at the heart of the enemy’s communications could do damage out of all proportion to their numbers’. In response Wavell, an admirer of Lawrence, maintained that a ‘trained guerrilla’ was impossible but believed it would be possible to train specialist uniformed troops to operate behind enemy lines and that ‘guerrilla warfare … is well worth reading and thinking about’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_19",
      "id": "fn1_19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" During army man-oeuvres in 1936 Wavell had Fox-Davies mount an unscheduled raid on the rear of the opponent’s forces to capture the enemy HQ, causing a premature end to the exercise. Wavell’s concept of regular troops operating in an irregular manner was at the heart of what became Holland’s vision for MI(R) and would have a major impact on MI(R)’s later operations in the Middle East and the broader development of Special Forces.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In gathering together historical precedents, Holland referred back to the use of the Cossacks against Napoleon’s army and the French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("francs-tireur")]), _vm._v(" who disrupted German lines of communication after the battle of Sedan in 1871, the more recent hit-and-run tactics of guerrillas in South Africa, China and Spain, and particularly British experience in Ireland."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_20",
      "id": "fn1_20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" He explained that ‘there is little doubt that the Irish made guerrilla warfare into a science, which has been followed since … It is proposed to base this present study on such information as can be obtained of Irish principles and their application by other revolutionaries subsequently.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_21",
      "id": "fn1_21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" He argued that if guerrilla organizations could be established in countries likely to be invaded by a shared enemy then this could divert enemy forces from the main battle; he was less hopeful of prospects for action in countries already occupied. Czechoslovakia had already"), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v(" been invaded, Poland, Romania and Yugoslavia seemed at particular risk from the Germans, and Libya, Ethiopia and Albania from the Italians. Holland began a ‘desk-top’ study of the wide range of available literature on the subject, including the Boer War (with "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kommando")]), _vm._v(" by Denys Reitz, published in 1932, having become required reading for army officers), T.E. Lawrence’s popular accounts of the First World War Arab Revolt, accounts of Russian experiences in the Caucasus and Central Asia, Trotsky’s writings on the Russian Civil War and the memoirs of guerrilla warfare by General von Lettow-Vorbeck in East Africa and Jósef Pilsudski in Poland. More recent were the instructions issued to Sinn Fein in its journal "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("An t’Oglach")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Volunteer")]), _vm._v("), Edgar Snow’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Red Star Over China")]), _vm._v(" (1937) and the Grand Mufti’s instructions to the Arab rebels in Palestine. The most recent contribution was Mao Tse Tung’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("On Guerrilla Warfare")]), _vm._v(", published in 1937 and probably privately translated by SIS before its first official translation into English in 1940. Although stressing political education, the basic tactics of guerrilla warfare described by Mao Tse Tung followed the now well-established canon that was later synthesized for MI(R) by Colin Gubbins. Holland’s sources also included the training instructions of the First World War Home Guard (Volunteer Training Corps), with the official history of the VTC claiming that ‘the force was to take the form of bands of irregulars, and its duty in case of invasion was to carry on a form of guerrilla warfare’."), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_22",
      "id": "fn1_22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")]), _vm._v(" The "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("VTC Regulations")]), _vm._v(" of 1916 explained:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("The object will be to constantly harass, annoy, and tire out the enemy, and to impede his progress, till a sufficient force can be assembled to smash him … They must therefore be prepared to move in the lightest manner without baggage of any kind; they must live in temporary shelters, and for this the country is amply suitable.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The British Army’s first manual on the topic had been "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Notes on Guerrilla Warfare in Ireland")]), _vm._v(" (1921), expanded as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Imperial Policing and Irregular Warfare")]), _vm._v(" in 1933 ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see below")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#page53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 53")]), _vm._v(" and Appendix 2). T.E. Lawrence also provided a definition of ‘Guerrilla Warfare’ in the 1929 edition of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Encyclopaedia Britannica")]), _vm._v(". This maintained ‘Guerrilla war is far more intellectual than a bayonet charge’ and concluded:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Rebellions can be made by 2% active in a striking force, and 98% passively sympathetic. The few active rebels must have the qualities of speed and endurance, ubiquity and independence of arteries of supply. They must have the technical equipment to destroy or paralyze the enemy’s organized communications, for irregular war is fairly Willisen’s definition of strategy, ‘the study of communication,’ in its extreme degree, of attack where the enemy is not. In fifty words: Granted mobility, security (in the form of denying targets to the enemy), time, and doctrine (the"), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v(" idea to convert every subject to friendliness), victory will rest with the insurgents, for the algebraical factors are in the end decisive, and against them perfections of means and spirit struggle quite in vain."), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_23",
      "id": "fn1_23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("After Lawrence’s death in 1935 came the best-selling Seven Pillars of Wisdom. Lawrence stressed the fundamental guerrilla tactics of mobility, attacking communication lines rather than direct frontal assault and the need to operate within a generally sympathetic population. With this weight of material, Gubbins’ later claim that ‘there was not a single book to be found in any library in any language which dealt with this subject’ – was part of the hyperbole he created around his own contribution in writing the pamphlets "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Art of Guerrilla Warfare")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Partisan Leader’s Handbook")]), _vm._v(" for MI(R) ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see below")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter04#page53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 53")]), _vm._v(")."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_24",
      "id": "fn1_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('h3', {
    staticClass: "ch-sub"
  }, [_vm._v("Scheme D, March 1939")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("While Jo Holland worked in lonely isolation in the War Office on his deskbased studies and was tied by the need to be publicly accountable for his budget, in SIS Laurence Grand rapidly expanded Section D and secretly prepared to take to the field on a very different basis."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_25",
      "id": "fn1_25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" Grand had begun work a few months earlier to research the potential of unavowable clandestine warfare against Germany, using sabotage, subversion and black propaganda and focused on a pre-emptive war against German economic assets from bases in neutral countries, using civilian agents. Holland found the obsessive security of Section D amusing. Staff were not supposed to acknowledge each other in the street and he would go up behind them and shout ‘boo’ in their ear, but together Grand and Holland created ‘Scheme D’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_26",
      "id": "fn1_26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" This both authorized Section D to immediately go to war and also provided a mechanism for the expansion of GS(R) by allowing it to tap into the secret budget of SIS. Together, they would offer ‘an alternative method of defence … to organised armed resistance … based on the experience we have had in India, Iraq, Ireland and Russia, i.e. the development of a combination of guerrilla and IRA [Irish Republican Army] tactics’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_27",
      "id": "fn1_27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Holland and Grand had been near-contemporaries (Grand being nine months younger) at both Rugby School and the Royal Military Academy Woolwich, and latterly had both been staff officers at the War Office, involved in plans for the mechanization of the army. Both were witty and charming but while Grand was very tall and elegant, his mind constantly racing with new ideas and eager for action, by comparison Holland was ‘short and burly’, a chain-smoker with a sometimes explosive temper but who took a more calculating and long-term approach in his thinking. According to Holland’s secretary/personal assistant, Joan Bright, ‘Grand was a volatile dreamer, Holland an unsmiling visionary’ but despite their different characters ‘he [Holland] and Grand got on well together’ and they remained close friends"), _c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v(" after the war."), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_28",
      "id": "fn1_28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")]), _vm._v(" This is contrary to the opinion expressed by Gubbins when claiming to speak for Holland after the latter’s death, saying Holland ‘had no faith in ‘‘D’’ [Grand], with his wild cat and fantastical schemes, never getting down to brass tacks and specific achievements’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_29",
      "id": "fn1_29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" This was a projection of Gubbins’ views and was by no means an accurate assessment, but has tended to be accepted without question. The truth was far more complicated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("‘Scheme D for Europe-wide sabotage and subversive operations’ was first presented by Grand to Stewart Menzies, then head of Section II (Military) of SIS on 20 March 1939, just days after the Nazi occupation of Prague. This event clearly focused the minds of those attending the subsequent meetings. The proposal went first to SIS as it would be expected to fund the expansion of GS(R), providing the basis of Grand’s later claim to have directed GS(R), or as it would become, MI(R). Mackenzie believed in 1947 that ‘the basic ideas of this paper are recognizably those of Colonel Holland; its style and its unquenchable optimism are certainly Colonel Grand’s’ and the report was concocted by both men for mutual benefit, from Holland’s perspective offering a clear pathway to expansion of GS(R)."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_30",
      "id": "fn1_30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" Menzies advised that the scheme should next be submitted to the War Office in the form of the Deputy Director of Military Intelligence (DDMI), W.E. van Cutsem, and two days later it had reached the Chief of the Imperial General Staff (Lord Gort) and the Director of Military Operations and Intelligence (Sir Henry Pownall)."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_31",
      "id": "fn1_31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" From there, it went to the Foreign Office, with the decisive meeting on 23 March attended by the Foreign Secretary (Lord Halifax) and the Colonial Secretary (Lord Cadogan), as well as by Lord Gort, Menzies and Grand. Holland was not present, either for reasons of military protocol or because he was content for Grand to present the scheme. Regarding occupied territories, Scheme D advocated")]), _vm._v(" "), _c('p', {
    staticClass: "rindent"
  }, [_vm._v("(a) creating the maximum of insecurity to occupying troops and occupying Gestapo;")]), _vm._v(" "), _c('p', {
    staticClass: "rindent1"
  }, [_vm._v("(b) creating the maximum of insecurity on the lines of communication;")]), _vm._v(" "), _c('p', {
    staticClass: "rindent1"
  }, [_vm._v("(c) encouragement of local desire for independence; and")]), _vm._v(" "), _c('p', {
    staticClass: "rindent2"
  }, [_vm._v("(d) making any fresh adventure, and the most recent in Czechoslovakia and Austria, as expensive as possible."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_32",
      "id": "fn1_32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The plan was predicated on the prevalent government view that the Nazi state was brittle and would implode under pressure from an economic blockade. Such a collapse could be assisted by large-scale risings in already occupied countries and preparation for resistance in countries that might be over-run in the future. The overall aim was ‘to ensure that no military effort could be made by the German Army without giving opportunity for such turmoil on its lines of communication as to render continued effort impossible’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_33",
      "id": "fn1_33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" Based on the supposed fragility of Nazi Germany, Scheme D proposed being ready for"), _c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v(" a general uprising in German-occupied territories in just three or four months, whilst a ‘combination of guerrilla and IRA tactics’ could bring about a collapse of the strategically important oil-rich Romania, if occupied, in just three weeks."), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_34",
      "id": "fn1_34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" The methodology drew on the practical experience of the British in confronting irregular warfare and it is clear that the IRA campaign in particular had seared its impact into the psyche of the War Office.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A series of country-by-country objectives was outlined: those neutral countries under the economic influence of Germany, the territories already occupied by Germany and Italy, and other countries thought to be at risk from future invasion. Scheme D was brutally honest about the methodology to be employed, including: ‘Where possible they would endeavour to execute members of the Gestapo with as much show as possible, to produce in the minds of the local inhabitants that the guerrillas were more to be feared than the occupying secret police.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_35",
      "id": "fn1_35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" This was said to be a lesson taken from the IRA. Arms would be supplied to Bohemia to enable the inhabitants ‘to commence operations on the lines of the Irish Terror in 1920–21’. Anticipated guerrilla organizations in Denmark, Holland and Poland would be supplied, as would any resistance groups within Germany and Austria. Popular risings in Italian-held Libya and Ethiopia would also be encouraged. An uncomfortable Lord Halifax for the Foreign Office said that he agreed in principle with the scheme, ‘which he now intended to forget’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_36",
      "id": "fn1_36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" Foreign Office reluctance to engage with the practical consequences of subversion was to prove a major handicap over the coming months. Lord Gort (CIGS) gave formal War Office approval and Section D was authorized to begin preparing civilian operational activity against Germany while GS(R), now part-funded by SIS, would develop a more military-based concept."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_37",
      "id": "fn1_37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" The expansion of G(R) would be facilitated by the attachment of around twenty-six army officers to Section D, including Jo Holland, whose experience ‘both on the North-West Frontier and in Ireland, will make him invaluable for planning in this connection’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_38",
      "id": "fn1_38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" Grand explained: ‘Jo Holland joined almost immediately and it was agreed that a new sub-section ‘‘DM’’ should be formed which would in general deal with all activities that could be carried out by uniformed troops.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_39",
      "id": "fn1_39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" It would operate primarily through military missions, and ensure coordination with the War Office, offering a more respectable version of irregular warfare than Section D. An MI(R) summary report in June 1939 accepted its role as a part of Section D, describing ‘Colonel Holland – then D/M of Section of D Organization’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_40",
      "id": "fn1_40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" Joan Bright, who witnessed the, at times, mutual bewilderment of the Section D spies and military officers of MI(R) working alongside each other, summed up the distinction thus:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Grand’s Section D deeds would be done by undercover men, spies and saboteurs, who, if caught, would be neither acknowledged nor defended"), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v(" by their government. Holland’s MI(R) plans would be subject to proper strategic and tactical requirements and carried out by men in the uniform of the established Armed Services for whom the normal conventions of war would operate."), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_41",
      "id": "fn1_41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This alliance should have meant that British Intelligence was able to cover the whole gamut of potential irregular operations but the partnership was blighted by the nervousness of the Foreign Office, a dismissive attitude in the War Office and the personal ambitions of Colin Gubbins. Holland later explained:")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Some explanation is needed of the respective spheres of MI(R) and the so-called ‘D’ organisation of the SIS. When a project is likely to involve military missions or to evolve into irregular military operations, or to require trained soldiers, it is within the sphere of MI(R). The ‘D’ organisation should deal with individual agents, minor sabotage in enemy country, and contact with secret foreign organizations."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_42",
      "id": "fn1_42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The relationship between GS(R) and Section D was now too uncomfortably close for War Office liking. Holland formally reported to the Deputy Chief of the Imperial General Staff and the Director of Military Intelligence but Grand was clear that, until the outbreak of war, what became MI(R) was a functional element of Section D. Joan Bright simply stated: ‘We became part of Section D.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_43",
      "id": "fn1_43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" Even Colin Gubbins’ account of his recruitment to MI(R) in April 1939 is ambiguous as to who was actually in charge. He says he was invited to a lunch by Holland but")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("In a private room at St Ermin’s Hotel I found that the real host, who was waiting for us there, was another sapper officer whom I also knew well. Over lunch he told us that he was the head of Section D and explained his charter."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_44",
      "id": "fn1_44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Within days of the agreement for Scheme D, on 3 April Holland produced a paper for the DCIGS and briefed him and the CIGS again on 13 April on what he casually called D/M."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_45",
      "id": "fn1_45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" The War Office was unhappy that one of its departments appeared subservient to SIS and in a high-powered meeting on 27 June between Holland and DCIGS, DMO&I, DDMO and DDMI, the original title of GS(R) was retained."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_46",
      "id": "fn1_46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" But the work was now moving from investigating the theory of irregular warfare to preparation for action and needed a more recognizable War Office status. It was agreed that the body was best placed under the then DDMI, Brigadier ‘Freddy’ Beaumont- Nesbitt, confirming its status as part of the Intelligence branch and GS(R) was formally rebranded as MI1(R), but was best known as MI(R) or MIR. The title was borrowed from a unit that had existed in 1918 to collect intelligence"), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v(" on Soviet Russia and this was in itself significant in light of one of its key target areas ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see below")]), _vm._v(", ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#page149",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 149")]), _vm._v("). The new MI(R) Charter of June 1939 took care to clearly distinguish between Section D and MI(R) with the role of MI(R) to earmark staff for training in sabotage and the theory of guerrilla warfare, but not necessarily to direct field operations."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_47",
      "id": "fn1_47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" Its tasks were")]), _vm._v(" "), _c('p', {
    staticClass: "rindent"
  }, [_vm._v("(a) the planning of para-military activities, under the direction of the DDMI;")]), _vm._v(" "), _c('p', {
    staticClass: "rindent1"
  }, [_vm._v("(b) liaison with MO branches as regards coordination with War Plans; and")]), _vm._v(" "), _c('p', {
    staticClass: "rindent2"
  }, [_vm._v("(c) preparatory action in peace in conjunction with other organizations.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("The geographical priorities were agreed as being Poland and Romania, then Libya and Ethiopia, Czechoslovakia and Albania. SIS agreed to provide additional funding up to a level of around £10,000 p.a. for new staff and the development of sabotage devices in what became MI(R)c. Holland was conflicted by the opportunities offered by Scheme D, still believing that, even after the outbreak of war, the essential role of MI(R) would be in research and that responsibility for field operations should be passed on to existing service departments – whilst not being convinced that they were yet ready for the challenge. He also doubted that central control of guerrilla activities would be possible from within the War Office but assumed that management would devolve to special branches of military missions cooperating with local guerrilla activities. Consequently, he considered that a central staffing of three officers would be sufficient prior to the outbreak of war, with himself in charge, War Office staff officer Major Colin Gubbins responsible for the ‘G.S. side’ (general service and training), and Royal Engineer Major Millis Jefferis on technical developments. All three were initially only seconded until April 1940. The additional staff requested in Scheme D would be seconded to Section D or be directly managed by regular military missions, with Jefferis acting principally as an adviser to Section D’s growing technical section. This minimalist vision soon changed, both because the War Office wanted to ensure the identity of MI(R) independent from Section D and through the practicalities of mounting the military missions. Staffing began to mushroom as MI(R) was given additional administrative responsibilities and, given the urgency of the situation, because the impatient Holland recruited officers in anticipation of formal agreement of projects that he hoped would eventually be managed elsewhere: ‘To save time in implementing decisions by anticipating action in the selection of personnel and on technical matters.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_48",
      "id": "fn1_48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" Once staff were gathered under its aegis, MI(R) then found itself under an assumption of responsibility for the projects and this began to overwhelm its research function."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_49",
      "id": "fn1_49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" Where possible, the careful Holland tried to economize. He tried"), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v(" to persuade George Larden, another former Rugby School pupil, then a regular Royal Artillery officer serving as adjutant to a London TA anti-aircraft regiment, to take two months’ leave in May 1939 in order to go to Romania and make an unofficial unpaid survey of their railway system on behalf of MI(R)."), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_50",
      "id": "fn1_50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")]), _vm._v(" He also resisted employing Stuart Macrae on a permanent basis for as long as possible, although placing increasing demands on his time with Oldham’s Press ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see below")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter03#page33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 33")]), _vm._v(").")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In acknowledgement of their new joint agenda, Section D moved out of the shabby basement of SIS HQ at 54 Broadway in London and moved around the corner to the 6th floor of a Victorian mansion block at 2 Caxton Street, where it was joined by the expanded MI(R). Eric Maschwitz described the early premises in Caxton Street as a cramped little office where the security was somewhat weakened by the staff cars and uniformed dispatch riders that were constantly parked outside it."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_51",
      "id": "fn1_51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" Sharing resources, the distinction between Section D and MI(R) could blur in practice. They jointly organized pre-war training courses at the adjacent Caxton Hall and Peter Wilkinson admitted that in later months ‘as much of my time was spent at the headquarters of Section D in Caxton Street as in MI(R). I was given a desk in their Balkan section and allotted the secret symbol DH/M’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_52",
      "id": "fn1_52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" In February 1940 he was spending three hours a day working under George Taylor."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_53",
      "id": "fn1_53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" Some staff, such as Kavan Elliott, moved from Section D to MI(R) while R.T. Cripps moved the other way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The legality of what was proposed under Scheme D continued to worry Lord Gort (CIGS), who was keen to distance the work of MI(R) from the War Office by insisting that the MI(R) contribution should be based upon Reserve or Territorial rather than Regular officers and that any of the latter should not participate ‘too openly’ or become involved in anything that, if discovered, might cause embarrassment."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_54",
      "id": "fn1_54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" The CIGS also insisted on having the final responsibility for implementing any future action. MI(R) would only become operational in circumstances when British military action was imminent, meaning that during the ‘phoney war’ MI(R) was characterized by position statements and desk-based studies, rather than activity in the field. This was of little concern to Holland, who saw the role of MI(R) as an advisory think-tank and was prepared to let Section D get on with the dirtier aspects of irregular warfare, operating without official sanction. By contrast, the assumption that MI(R) would work largely at an official level in partnership with the General Staffs of threatened countries proved naïve in a period of German ascendency. The perceptive CIGS also warned against any appearance of forcing advice on foreign General Staffs (the Belgians were already showing signs of irritation with the British and French in this respect)."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_55",
      "id": "fn1_55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("With his small core team of Gubbins and Jefferis in place during April 1939, Holland provided an internal memo to clarify their basic objectives:")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "rindent"
  }, [_vm._v("(a) to study guerrilla methods and produce a guerrilla Field Service Regulations manual;")]), _vm._v(" "), _c('p', {
    staticClass: "rindent1"
  }, [_vm._v("(b) to evolve destructive devices suitable for the use of guerrillas; and")])]), _c('p', {
    staticClass: "rindent2"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("(c) to evolve procedure and machinery for operating guerrilla activities."), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_56",
      "id": "fn1_56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Holland also sent a letter on 19 April 1939 to the military attachés in Warsaw, Bucharest, Athens and Belgrade asking for their opinion on his proposals to delay an enemy advance, asking what types of explosives were in standard use and specifically what railway or road bridges should be considered for demolition. He particularly wanted to know whether there were any existing plans for guerrilla or para-military action in their countries and raised the touchy matter of the likely reaction to Britain giving advice on the subject."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_57",
      "id": "fn1_57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first task was to produce a field service manual, in line with British Army tradition which demanded a documented regulation for each and every eventuality. Holland originally envisaged this as being substantial, with an introduction explaining the principles and tactics of guerrilla warfare, followed by chapters dealing with their detailed application in each country."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_58",
      "id": "fn1_58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" This had to be scaled back to three simple pamphlets that could at least establish the credentials of MI(R) in its dealings with foreign General Staffs and then might be used as the basis for further expansion. Majors Gubbins and Jefferis were recruited to complete these pamphlets. Royal Artillery and War Office staff officer Colin Gubbins ("), _c('span', {
    attrs: {
      "href": "#/xhtml/Plates#P_2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 2")]), _vm._v(") had an awareness of guerrilla warfare from service in Russia and Ireland but more importantly had specialisms in linguistics, recruitment and training from the policy-making section of the Military Training Directorate (MT1). He also had an established interest in Russia, Poland and Czechoslovakia which suited the immediate priorities of MI(R). Millis Jefferis ("), _c('span', {
    attrs: {
      "href": "#/xhtml/Plates#P_3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 3")]), _vm._v(") came from a field company of the Royal Engineers (who MI(R) relied on for implementing many of its plans) with a reputation as an inventive explosives expert, to write an explosives guide and then to develop explosive devices for the use of MI(R) and the wider military. Keeping these quick-thinking individuals grounded was Joan Bright, recruited by John Walter (a Royal Engineer officer, then of Section D and later MI(R)) as a secretary, who established a wider reputation as an efficient office organizer. Gubbins regarded Joan Bright as ‘a woman of considerable culture and great verve, working really as a GSO2 not as a Secretary … We shared some tough times.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_59",
      "id": "fn1_59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" Eric Mockler-Ferryman, who worked in the DMI, recalled his impressions: ‘I can well imagine that you ruled visiting generals and admirals with an iron hand in a velvet glove.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_60",
      "id": "fn1_60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])]), _vm._v(" According to"), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v(" Macrae, Bright kept the ‘bag of gold’ (the secret funding from SIS) with the account book, and ‘more or less ran the show’."), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_61",
      "id": "fn1_61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")]), _vm._v(" She was later responsible for compiling the MI(R) War Diary."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_62",
      "id": "fn1_62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" Women with such a role were unusual within the War Office at the time and therefore attracted attention but Holland would have noted that Section D was prepared to place women in positions of responsibility (and SIS already had female intelligence officers). Lesley Wauchope joined as another secretary and was described by Bright as having ‘the face of an untroubled Madonna’ but with a wicked wit and no respecter of other’s pretensions. Together they ‘giggled at the same things as we typed our way through the hectic months of reality and idiocy’ preceding the outbreak of war."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_63",
      "id": "fn1_63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gubbins explained how he was recruited. Holland came up to his desk at the War Office and said ‘You are to lunch with me; the CIGS says so.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_64",
      "id": "fn1_64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" They went to a private room at the St Ermin’s Hotel where they met Laurence Grand. All three men had attended the Royal Military Academy Woolwich where Gubbins was senior to both Holland and Grand. The three officers later came across each other in the War Office on various aspects of mechanization (Gubbins was in MT1, Holland in SD7 and Grand was Deputy Assistant Director of Mechanization). Holland may also have met Gubbins during service in Ireland, although there is no evidence that they served together there or were particular friends. Gubbins had served in the Soviet and Polish section of the DMI and was a qualified interpreter in Russian, Urdu and French; he also spoke Japanese (having been born in Japan). He had also visited Czechoslovakia in October 1938 as part of the team monitoring the withdrawal of Czech troops from the Sudetenland. Gubbins was no expert on guerrilla warfare but his expertise in training from MT1 was urgently required. Joan Bright described Gubbins as ‘quiet-mannered, quiet-spoken, energetic, efficient and charming. He was a ‘‘still waters running deep’’ sort of man, he had just enough of the buccaneer in him to make lesser men underrate his gifts of leadership, courage and integrity’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_65",
      "id": "fn1_65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" He cultivated a devil- may-care attitude and according to Peter Wilkinson, his close colleague and biographer, ‘I have seldom met a man more vigorous and a more inspiring soldier.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_66",
      "id": "fn1_66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" Like Grand and Holland, he inspired great loyalty among his subordinates but there was also a darker side to his character with a reputation for ambition and ruthlessness. Writing in May 1941, Robert Bruce Lockhart (Director-General of the Political Warfare Executive) commented ‘Jebb had said the other day that Gubbins was the most ambitious man he knew. If that is Jebb’s verdict, you know what Gubbins must be!’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_67",
      "id": "fn1_67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" Jo Hollis, Secretary to the Chiefs of Staff Committee, went further and later declared that Gubbins was ‘evil’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_68",
      "id": "fn1_68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" Even Wilkinson had to admit ‘he was not much liked by his contemporaries … they thought him a little pushy and ambitious’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_69",
      "id": "fn1_69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" This aspect"), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v(" of his character would have a major impact on MI(R) and its relationship to Section D of SIS.")])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("It was a prolific few months. In the midst of exploratory visits to Poland, the Baltic and the Balkans ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see below")]), _vm._v(", ")]), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter06#page68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 68")]), _vm._v("), Gubbins quickly produced "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Partisan Leader’s Handbook")]), _vm._v(" (40pp) and, with Holland, the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Art of Guerrilla Warfare")]), _vm._v(" (22pp), distilling key points from existing publications and Holland’s philosophy on the subject into a concise, practical outline of strategy and field guide. At the same time Millis Jefferis produced "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("How to Use High Explosives")]), _vm._v(" (16pp) as a guide to service explosives and devices. The three pamphlets were important statements of MI(R)’s credibility and were subsequently translated into more than sixteen languages and widely circulated, printed pocket-sized on thin paper between plain brown covers. Some were produced on edible rice paper."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_70",
      "id": "fn1_70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" At a more strategic level, on 1 June 1939 Holland produced his second report in the GS(R) series, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Report No. 8: Investigation of the possibilities of Guerrilla Activities")]), _vm._v(" ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see")]), _vm._v(" Appendix 2) for the DCIGS, which summarized their progress to date."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_71",
      "id": "fn1_71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" This stressed Holland’s core belief that irregular warfare had to be coordinated and used as a tactic to support conventional warfare. If so, ‘it should, in favourable circumstances, cause such a diversion of enemy strength as eventually to present decisive opportunities to the main forces of his opponent. It is therefore an auxiliary method of war of which we have not yet sufficiently exploited the possibilities.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_72",
      "id": "fn1_72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" Annexed to the report was a summary of Gubbins’ visits to Poland, the Baltic and the Balkans, together with reports by Jefferis on the initial work in creating sabotage devices and a report on the progress made in training and recruitment. The potential demonstrated by these publications was sufficient, on 19 July, for Holland’s deferred posting to Malta to be cancelled."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_73",
      "id": "fn1_73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The main strategy of the expanding MI(R) was to dispatch military missions to neutral and Allied governments and supply material to foreign resistance organizations ("), _c('a', {
    attrs: {
      "href": "#/xhtml/Chapter01#fig.2"
    }
  }, [_vm._v("Fig. 2")]), _vm._v("). With war considered likely within four months, Holland wanted to establish the widest possible range of introductions, hence Gubbins’ whistle-stop tours across Europe. Officially, the development of new sabotage devices was also put on temporary hold in favour of arranging the supply of existing materials to the target countries, although this was ignored by the ever-inventive Millis Jefferis. The overall priority was to provide Poland with as much of MI(R)’s specialist munitions as possible but an assessment of the resources needed to sabotage the Romanian oil wells was also considered urgent."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_74",
      "id": "fn1_74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Military missions had been used extensively from 1917 in many parts of the world to first combat German intrigue and later to try to limit the post-war chaos, as well as trying to exert a British influence on world events. Now MI(R) ‘Active’ missions were intended to advise allied General Staffs and guerrilla forces in on-going theatres of war with the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Art of Guerrilla Warfare")]), _vm._v(" (see Appendix 2) anticipated the attachment of military missions to partisan forces (first achieved with Mission 101 in Ethiopia):")]), _vm._v(" "), _c('div', {
    staticClass: "img_container1a",
    attrs: {
      "id": "fig.2"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg32_a.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Figure 2. Summary list of MI(R) missions September 1939–October 1940. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("TNA HS 8/263")]), _vm._v(")")])])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('div', {
    staticClass: "block"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("In cases where the guerrillas are a nation in arms, or part thereof, fighting for their freedom in alliance with or assisted and instigated by a third power which is willing and anxious to render all assistance to them, it will usually be advisable for that third power to be represented by a mission at the headquarters of the guerrilla movement. The duties ofsuch a mission would be to provide expert advice, to ensure liaison, to arrange the supply of arms, ammunition, money, etc., and to provide leaders and assistants to leaders, if such were found to be necessary."), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_75",
      "id": "fn1_75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("‘Passive’ missions to amenable neutral countries were intended to organize anti-‘fifth column’ activities in advance of any invasion, together with raising and training units of local troops trained in guerrilla warfare. But in 1940 neutral governments were reluctant to show overt support for the retreating Allies and so there were attempts to send undercover ‘Shadow’ missions as a preliminary to the subsequent dispatch of formal missions once allowed by a change in the political climate. Small ‘Inspection’ missions to neutral countries would also monitor the organization of British communities and try to improve their ability to counter German propaganda. Individual officers might also be sent as ‘missionaries’, which evolved into sending out officers as assistant military attachés.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was the task of MI5 to identify enemy networks across the Empire but preparations for a military response to any ‘fifth column’ threat was a key purpose of MI(R). There was consequently a strong MI5 interest in some missions and MI(R) had a major role in creating the counter-espionage SIME (Security Intelligence Middle East: see below, "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#page151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 151")]), _vm._v("). Although frequently descending into paranoia, concern over a Nazi ‘fifth column’ was well-founded. The pro-Nazi elements of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Volksdeutsche")]), _vm._v(" of the Sudetenland and Silesia steered the crises of 1937–1939 and there was concern over the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ausland")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Landesgruppen")]), _vm._v(" organizations operating from German communities abroad. By 1940 the Germans had also developed the infiltration of military units to a level of which British exponents of irregular warfare at the time could only dream. The 800th Special Purpose Instruction Regiment, Brandenburg (the Brandenburg Regiment) was formed to operate in advance of the German main forces, often in civilian dress or Allied uniform, to seize and hold lines of communication or strategic assets, and proved very effective in the invasions of Denmark, the Low Countries and France.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Foreign Office was suspicious and even hostile to pre-emptive Intelligence operations and some ambassadors refused to accept MI(R) missions into the country for fear of compromising their diplomatic activities. Holland shared the Foreign Office’s righteous abhorrence at the start of the war of"), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v(" ‘dabbling’ in local politics but Section D had no such qualms and Laurence Grand may have influenced the implicit acceptance of this strategy in Gubbins ’"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Art of Guerrilla Warfare")]), _vm._v("."), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_76",
      "id": "fn1_76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")]), _vm._v(" In practice, interference could not be wholly avoided when trying to encourage a local population towards supporting the Allied cause and in Ethiopia MI(R) was drawn into internal politics with rival ‘local experts’ supporting different ethnic groupings. In the Belgian Congo an explicit aim of Military Mission No. 19 was to collect information on the sympathies of the army and business leaders in preparation for a possible British invasion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The military missions proved difficult to organize and it was subsequently proposed to simply install MI(R) officers in legations as assistant military attachés. The latter could try to encourage foreign General Staffs to develop plans for guerrilla warfare but, perhaps more importantly, it was hoped they would also act as a contact point between the various British Intelligence agencies. The new AMAs were drawn from the list of suitable officers prepared by MI(R) but they had minimal training, dismissed as only the necessary ‘low-grade’ qualifications for MI(R) work. They had received just two weeks’ training at the War Office and did not necessarily have the diplomatic skills of Commander Watson in Bucharest, who successfully worked between MI(R), Section D and NID ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see below")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#page151",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 151")]), _vm._v(" and "), _c('span', {
    attrs: {
      "href": "#/xhtml/Plates#P_24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Plate 24")]), _vm._v("). Gubbins wanted them to go further and coordinate the work of the existing Intelligence agencies but in practice MI(R) had little to offer beyond the variable personal skills of the AMAs, and with no infrastructure to support them they could not fulfil Gubbins’ dream of creating a new network independent of Section D.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were also attempts to set up broader Intelligence Bureaux to investigate the possibilities for irregular activity in already occupied territories and the Caucasus. These were based on the precedent of the Arab Bureau of the GHQ Egyptian Expeditionary Force in the First World War, which encouraged the Arab Revolt. They were to be flexible, containing representation from Section D so that the appropriate outcome might be either an MI(R) military mission or a Section D sabotage and subversion project. A corollary of the Bureaux was to send out officers to collect intelligence and Holland bemoaned the fact that the collection of information no longer seemed to be a function of Military Intelligence and had been surrendered to SIS. But there was concern that MI(R) should not develop as a new intelligence-gathering agency and the concept was overtaken by the creation of SOE; a report in the MI(R) War Diary complained that the embryonic Bureaux were ‘surrendered’ to Dalton’s SOE, ‘thus allowing planning which should have been intimately connected with regular [War Office] plans to pass out of their hands.’"), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_77",
      "id": "fn1_77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With war expected imminently, Holland determined that MI(R) would focus its limited resources on assisting countries which remained unoccupied,"), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v(" rather than those which had already fallen to the Germans."), _c('sup', {
    staticClass: "sup"
  })]), _c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_78",
      "id": "fn1_78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")]), _vm._v(" This approach would be soon tested with the fall of Poland. In June 1939 Holland explained that ‘from now until the middle of August we must aim primarily at getting anything ready that we can in the time’."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_79",
      "id": "fn1_79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" Gubbins was at the forefront of this new phase of urgency and his series of foreign tours attempted to lay the groundwork for cooperation with foreign General Staffs. His work centred on Poland, as the likely spark to ignite the Second World War, where its General Staff already had a guerrilla organization. He made at least two visits in June and August, before returning with the official mission led by General Carton de Wiart ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see")]), _vm._v(" Chapter Six). Gubbins worked almost exclusively on issues related to Poland until April 1940 and this diversion to operational matters away from the London office of MI(R) gave him a different perspective from Holland. Prior to the formal outbreak of war, the only way to disrupt the economy of Germany was by unavowable means but this placed MI(R) as the junior partner with Section D and caused great frustration to the ambitious Gubbins, who joined MI(R) after the division of responsibilities in Scheme D had already been agreed. Gubbins was aghast at what he saw as the amateurishness and extravagance of some of what were described as the ‘wilder’ projects of Section D, but at the same time he admitted being envious of its risk-taking in contrast to the ponderous nature of the War Office."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_80",
      "id": "fn1_80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Only three months after being empowered by Scheme D, MI(R)’s first progress report of 10 July 1939 unsurprisingly struggled to offer concrete results but importantly it pointed to having made contact with a large number of potential recruits for Military Intelligence work, drawn from a list compiled with the DMI, and noted that around seventy had already received preliminary training. The three pamphlets were now being printed into other languages and there was already some limited production of Jefferis’ innovative sabotage devices ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see")]), _vm._v(" Chapter Three)."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_81",
      "id": "fn1_81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" A month later in August 1939 there were still no real plans for action, although Holland offered up the vague hope of future partnership with Poland, Romania and Czechoslovakia."), _c('sup', {
    staticClass: "sup"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/Notes#1fn_82",
      "id": "fn1_82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" In Albania, conditions for a successful rebellion were said to be deteriorating and any action was increasingly hampered by the fear of antagonizing Italy and precipitating the latter’s entry into the war. In Libya it was determined that any rebellion needed to be accompanied by successful military action and so MI(R) would provide a liaison officer between Wavell’s new Middle East Command and the potential rebels (Lieutenant Colonel David Bromilow was dispatched a month later, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see below")]), _vm._v(", "), _c('span', {
    attrs: {
      "href": "#/xhtml/Chapter10#page168",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("p. 168")]), _vm._v("). The situation in Ethiopia was also thought to be deteriorating but in early July 1939 a conference at the Foreign Office had made MI(R) responsible for providing arms and funding to the rebels. It was also proposed to send Peter Fleming and Martin Lindsay on a reconnaissance mission to China (under cover of working for the Ministry of"), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v(" Information), to establish what help the British could provide to the 1 million Chinese troops currently engaged in guerrilla warfare against the Japanese ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("see below")]), _vm._v(", p. 178). Despite displaying considerable energy, the conclusions of the August 1939 progress report remained pessimistic, and its adherence to traditional War Office bureaucracy in the face of the imminent outbreak of war contrasted with Section D, which had already moved into direct action.")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8418ec00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter01.vue
// module id = 87
// module chunks = 0